import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import TipoAliquotaService from 'business/cadastro/fiscal/tipoAliquota/tipoAliquotaService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'

export default function TipoAliquota() {

    const [service] = useState(() => new TipoAliquotaService())

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="descricao_tipali" form={form} service={service} type="textarea"  label="Descrição" />

                    </GridForm>

                </TabPanel>
                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
